import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '@/lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'block w-full rounded-md border border-stone-300 dark:border-stone-700 bg-white dark:bg-stone-900 px-3 py-2 text-sm',
        'placeholder:text-stone-400',
        'focus:border-forge-500 focus:outline-none focus:ring-1 focus:ring-forge-500',
        'disabled:cursor-not-allowed disabled:bg-stone-50',
        'dark:border-stone-700 dark:bg-stone-900 dark:text-stone-100',
        'dark:placeholder:text-stone-500 dark:disabled:bg-stone-800',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
